import { render, staticRenderFns } from "./giftrecord.vue?vue&type=template&id=224906d3&scoped=true&"
import script from "./giftrecord.vue?vue&type=script&lang=js&"
export * from "./giftrecord.vue?vue&type=script&lang=js&"
import style0 from "./giftrecord.vue?vue&type=style&index=0&id=224906d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224906d3",
  null
  
)

export default component.exports